<template>
  <div class="animated fadeIn" style="overflow: hidden; max-width: 100%;">
    <b-row style="flex-wrap: nowrap; overflow: hidden;">
      <!-- Start left layout -->
      <b-col md="5" class="left-side p-0">
        <el-card shadow="never" class="el-card--form">
          <el-form ref="formCreateDocumentIn" :model="mData.dataForm" :rules="mData.validForm" @submit.native.prevent
            label-width="127px">
            <b-row>
              <b-col>
                <el-form-item label="Tên văn bản" prop="name">
                  <el-input type="text" v-model="mData.dataForm.name" placeholder="Nhập nội dung"
                    maxlength="255"></el-input>
                </el-form-item>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <el-form-item label="Trích yếu nội dung văn bản" prop="description">
                  <el-input type="textarea" v-model="mData.dataForm.description" placeholder="Nhập nội dung" clearable
                    :autosize="{ minRows: 4 }" show-word-limit maxlength="500" resize="none"></el-input>
                </el-form-item>
              </b-col>
            </b-row>
            <el-divider></el-divider>
            <b-row class="mb-1 mt-2">
              <b-col md="12">
                <el-form-item label="Ngành" prop="business_id">
                  <el-select v-model="mData.dataForm.business_id"
                    @blur="validateFieldMethod(`business_id`, mData.dataForm.business_id)" filterable clearable
                    placeholder="">
                    <el-option v-for="item in mData.dataDefault.listDocumentBusiness" :key="item.id" :label="item.name"
                      :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </b-col>
            </b-row>
            <b-row class="mb-1 mt-2">
              <b-col md="12">
                <el-form-item label="Loại văn bản" prop="document_category_id">
                  <el-select v-model="mData.dataForm.document_category_id" filterable clearable
                    ref="document_category_id">
                    <el-option v-for="item in mData.dataDefault.listDocumentType" :key="item.id" :label="item.name"
                      :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </b-col>
            </b-row>
            <b-row class="mb-1 mt-2">
              <b-col md="12">
                <el-form-item label="Số ký hiệu" prop="book_number">
                  <el-input type="text" v-model.trim="mData.dataForm.book_number" @change="
                      () => {
                        mData.dataForm.book_number =
                          mData.dataForm.book_number.toUpperCase();
                      }
                    " placeholder="(X)/QĐ-(Y)-(Z)" maxlength="255">
                  </el-input>
                  <el-tooltip class="item" effect="dark" placement="top-start">
                    <div slot="content">
                      X: Số ký hiệu văn bản (Theo loại văn bản ở trên) <br />
                      Y: Chữ viết tắt của cơ quan, đơn vị ban hành văn bản<br />
                      Z: Chữ viết tắt của đơn vị ban hành văn bản
                    </div>
                    <i class="fal fa-question-circle"></i>
                  </el-tooltip>
                </el-form-item>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <el-form-item label="Độ khẩn" prop="">
                  <el-select v-model="mData.dataForm.urgency_id" filterable clearable>
                    <el-option v-for="item in mData.dataDefault.listDocumentUrgency" :key="item.id" :label="item.name"
                      :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </b-col>
              <b-col md="12">
                <el-form-item label="Độ mật" prop="">
                  <el-select v-model="mData.dataForm.secret_id" filterable clearable>
                    <el-option v-for="item in mData.dataDefault.listDocumentSecret" :key="item.id" :label="item.name"
                      :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <el-form-item label="Hình thức" prop="">
                  <el-select v-model="mData.dataForm.type" filterable clearable>
                    <el-option v-for="item in mData.dataDefault.listDocumentOp" :key="item.value" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </b-col>
            </b-row>
            <el-divider></el-divider>
            <div v-if="!isDraggable">
              <b-row v-if="mData.dataForm.signers.length > 0">
                <el-form-item>
                  <template scoped slot="label">
                    <span class="el-form-item__label"  >Người ký</span>
                  </template>
                  <b-row class="signers-container" v-for="(item, index) in mData.dataForm.signers" :key="index">
                    <b-col md="6">
                      <div :label="index == 0 ? 'Người ký' : ''" :prop="`signers[${index}].user_id`"
                        :key="componentRerender1">
                        <el-select v-model="item.user_id" filterable @change="
                        fn_getManipulatelyPosition(item.user_id, index, true, item.position_id, 'user_id')
                      " @blur="validateFieldMethod(`signers[${index}].user_id`, item.user_id)" @input="forceUpdateUI">
                          <el-option v-for="item in mData.dataDefault.listEmployee" :key="item.id"
                            :label="fn_setLabelRespectively(item)" :value="item.id"></el-option>
                        </el-select>
                      </div>
                    </b-col>
                    <b-col md="3" class="pl-0">
                      <el-form-item class="form-item--no-label" :prop="`signers[${index}].position_id`"
                        :key="componentRerender2">
                        <el-select v-model="item.position_id"
                          @blur="validateFieldMethod(`signers[${index}].position_id`, item.position_id)"
                          @change="checkDulicateUserVsPosition(item.user_id, item.position_id, index, 'position_id')"
                          clearable filterable :disabled="!item.user_id" @input="forceUpdateUI">
                          <el-option v-for="item in arrTwoWay[item.user_id]" :key="item.position_id"
                            :label="item.position_name" :value="item.position_id"></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <i class="el-icon-close" @click="removeSigner(index)" title="Xóa"></i>
                    <b-col md="1" class="pl-0" v-if="mData.dataForm.signers.length > 0">
                      <div class="custom-checkbox">
                        <el-checkbox v-model="item.is_digital_signature" :label="null" @change="handleChangeSignature(index,item )"
                          :disabled="index > 0 && mData.dataForm.signers[index - 1].is_digital_signature">
                        </el-checkbox>
                        <div class="checkbox-label">Chữ ký số</div>
                      </div>
                    </b-col>
                  </b-row>
                </el-form-item>
              </b-row>

            </div>
            <!-- Start Draggable -->
            <b-row v-if="isDraggable">
              <b-col xl="3" md="3" lg="2" class="pr-0">
                <p class="el-form-item__label mt-2">Người ký</p>
              </b-col>
              <b-col xl="9" md="9" lg="10" :key="componentRerender3">
                <draggable class="dragArea list-group w-full" :list="mData.dataForm.signers"
                  @change="reRenderDraggable">
                  <transition-group name="listSigner">
                    <div class="list-group-item p-1 rounded-md text-center mb-2"
                      v-for="(el, i) in mData.dataForm.signers" :key="el.user_id">
                      <div class="single__item">
                        <span class="single__item-name">
                          {{ i + 1 }}. <span class="span__block-overflow-100">{{ el.user_no }}</span> {{ el.user_name }}
                          {{ el.position_name ? '(' + el.position_name + ')': ''}}
                        </span>
                        <i class="fal fa-bars single__item-bar"></i>
                      </div>
                    </div>
                  </transition-group>
                </draggable>
              </b-col>
            </b-row>
            <!-- End Draggable -->
            <b-row class="mb-2" v-if="!isDraggable">
              <b-col :md="mData.dataForm.signers && mData.dataForm.signers.length > 1 ? 8 : 12">
                <div class="btn-add-signer" @click="addSigner()">
                  + Thêm người ký
                </div>
              </b-col>
              <b-col md="4" class="pl-0" v-if="mData.dataForm.signers && mData.dataForm.signers.length > 1">
                <div class="btn-arrange" @click="fn_checkIsSelected()">
                  <i class="isax-arrow-3 mr-2" style="font-size: 14px" />
                  Sắp xếp
                </div>
              </b-col>
            </b-row>
            <b-row v-if="isDraggable">
              <b-col xl="3" md="3" lg="2"></b-col>
              <b-col xl="9" md="9" lg="10">
                <div class="btn-arrange-complete" @click="isDraggable = false">
                  <i class="el-icon-check ml-2 mr-1"></i> Hoàn tất sắp xếp
                </div>
              </b-col>
            </b-row>
            <el-divider></el-divider>
            <b-row>
              <b-col md="12">
                <el-form-item label="Đính kèm" prop="">
                  <el-upload :auto-upload="false" list-type="text" action
                    :accept="mData.fileUploadOption.fileOther.accept" :on-change="uploadOtherFiles"
                    :on-preview="previewOtherFiles" :on-remove="removeOtherFiles"
                    :file-list="mData.fileUploadOption.fileOther.fileList"
                    :limit="mData.fileUploadOption.fileOther.limit" multiple drag>
                    <div class="el-upload__tip">
                      <div class="
                          d-flex
                          justify-content-center
                          align-items-center
                          mb-1
                        ">
                        <i class="isax-document-text-1 mr-1"></i>
                        <p>
                          <span style="color: #1e3cd7">Chọn file</span> hoặc kéo
                          thả file vào đây
                        </p>
                      </div>
                      <p style="color: #7e7e7e; line-height: 24px">
                        Kích thước tập tin không quá 20MB. <br />
                        Định dạng cho phép là pdf, docx, doc, xlsx, xls.
                      </p>
                    </div>
                  </el-upload>
                </el-form-item>
              </b-col>
            </b-row>
            <el-divider v-if="isEdit"></el-divider>
            <b-row v-if="isEdit">
              <b-col md="12">
                <el-form-item label="Từ công văn" prop="">
                  <el-upload :auto-upload="false" list-type="text" action
                    :accept="mData.fileUploadOption.fileMain.accept" :on-change="uploadFile" :on-preview="previewFile"
                    :on-remove="removeFile" :file-list="mData.fileUploadOption.fileMain.fileList"
                    :limit="mData.fileUploadOption.fileMain.limit" multiple disabled>
                  </el-upload>
                </el-form-item>
              </b-col>
            </b-row>
          </el-form>
        </el-card>
      </b-col>
      <!-- End left layout -->

      <!-- Start right layout -->
      <b-col md="7" class="pr-0" style="overflow: hidden; min-width: 0;">
        <div class="right-side" v-if="mData.fileUploadOption.fileMain.fileList.length == 0">
          <el-upload ref="upload" class="upload" :auto-upload="false" list-type="text" action
            :accept="mData.fileUploadOption.fileMain.accept" :on-change="uploadFile" :on-preview="previewFile"
            :on-remove="removeFile" :file-list="mData.fileUploadOption.fileMain.fileList"
            :limit="mData.fileUploadOption.fileMain.limit" drag :show-file-list="false">
            <div class="el-upload__tip">
              <div class="
                  d-flex
                  flex-column
                  justify-content-center
                  align-items-center
                  mb-3
                ">
                <i class="icon isax-document-text-1 mb-3"></i>
                <p class="bold" style="font-size: 24px">
                  <span class="bold" style="color: #1e3cd7">Chọn file</span>
                  hoặc kéo thả file vào đây
                </p>
              </div>
              <p class="mb-3" style="color: #7e7e7e; line-height: 24px">
                Định dạng cho phép là: pdf, doc, docx, xlsx, xls <br />
                Với file doc, docx, xlsx, xls (kích thước tối đa 5MB) <br />
                Với file pdf (kích thước tối đa 20MB)
              </p>
            </div>
          </el-upload>
          <!-- <p class="text-center download-ref">Tải file mẫu</p> -->
          <el-divider class="divider-custom">Hoặc</el-divider>
          <div class="to__draff__documnet" @click="fn_goToTemplateCreate">
            <div class="icon__block mb-3">
              <i class="icon isax-document-cloud"></i>
            </div>
            <div class="text__block">
              <p class="bold mb-3 main__text">Điền mẫu văn bản trực tuyến</p>
              <p class="sub__text">
                Điền file mẫu giúp tiết kiệm thời gian tải file mẫu và upload
                file đã điền của bạn.
              </p>
            </div>
          </div>

        </div>
        <div class="right-side" v-if="url">
          <div v-if="!isPdf" class="preview__file-container">
            <VueDocPreview :key="`create-office-${previewRenderKey}`" :value="url" type="office" class="h-100" />
          </div>
          <div v-if="isPdf" class="preview__file-container pdf-content">
            <ViewPdf
              v-if="previewFileId"
              :key="`create-pdf-${previewRenderKey}-${previewFileId}`"
              :fileId="previewFileId"
              :currentPage="1"
              :syncDropzoneWidth="false"
            />
          </div>
          <div class="text-center remove__file-footer" v-if="url && !mData.dataForm.ref_id" @click="removeFile">
            <p class="text-white">Xóa file đã tải và chọn lại</p>
          </div>
        </div>
      </b-col>
      <!-- End right layout -->
    </b-row>
    <!-- Start Manipulate buttons -->
    <div class="d-flex justify-content-between align-items-center">
      <div class="d-flex justify-content-between align-items-center">
        <el-checkbox v-model="mData.dataForm.publish.is_auto" :disabled="mData.dataForm.ref_id ? true : false">Ban hành
          tự động</el-checkbox>
        <el-checkbox v-model="mData.dataForm.effected_date.is_has_effected_after_signed" class="mr-4"
          @input="forceUpdateUI">Hiệu lực sau khi ký</el-checkbox>
        <el-date-picker
          v-if="!mData.dataForm.effected_date || mData.dataForm.effected_date && !mData.dataForm.effected_date.is_has_effected_after_signed"
          class="datePicker" type="date" v-model="mData.dataForm.effected_date.start_effected_at"
          placeholder="Ngày hiệu lực" format="dd/MM/yyyy" prefix-icon="isax-calendar-1" :clearable="false"
          title="Ngày hiệu lực" ref="startEffectedDate" @input="forceUpdateUI"></el-date-picker>
      </div>

      <div class="text-right mt-3 pb-3">
        <el-button class="btn__doc btn__doc-back" @click="fn_goBack()">Quay lại</el-button>
        <el-button v-if="viewMode == 'create'" :disabled="!mData.dataForm.doc_file.doc_id"
          class="btn__doc btn__doc-transfer" @click="fn_submitForm('create')">Thêm văn bản</el-button>
        <el-button v-if="viewMode == 'update'" :disabled="!mData.dataForm.doc_file.doc_id"
          class="btn__doc btn__doc-transfer" @click="fn_submitForm('update')">Lưu</el-button>
      </div>
    </div>
    <!-- End Manipulate buttons -->
    <Loading v-if="loading" />
  </div>
</template>

<script>
import ExtensionService from "../../../service/ExtensionService";
import MethodService from "../../../service/MethodService";
import ValidService from "../../../service/ValidService";
import DocumentApi from "../../../moduleApi/DocumentApi";
import FileApi from "../../../moduleApi/FileApi";
import OrganizationModelApi from "../../../moduleApi/OrganizationModelApi";
import draggable from "vuedraggable";
import VueDocPreview from "vue-doc-preview";
import _ from "lodash";
import { fnDocMixins } from "./DocumentMixins/fnDocMixins";
import { dataDocMixins } from "./DocumentMixins/dataDocMixins";
import Loading from "@/component/Loading";
import ViewPdf from "@/component/Draggable/ViewPdf";

export default {
  mixins: [dataDocMixins, fnDocMixins],
  components: {
    draggable,
    Loading,
    ViewPdf,
    VueDocPreview,
  },
  data() {
    return {
      arrTwoWay: [],
      url: "",
      fileExtension: "",
      isPdf: false,
      previewFileId: "",
      previewRenderKey: 0,
      isDraggable: false,
      major: "",
      isAutoPublish: false,
      isEffectedAfterSign: true,
      isEdit: false,
      loading: false,
      dataDefault: {
        listPosition: [],
      },
      componentRerender1: 0,
      componentRerender2: 0,
      componentRerender3: 0,
    };
  },
  methods: {
    getOfficeViewerUrl(fileUrl) {
      return fileUrl ? ExtensionService.getOfficeViewerUrl(fileUrl) : "";
    },
    applyPreviewFile(fileDetail) {
      if (!fileDetail || !fileDetail.id) {
        this.url = "";
        this.isPdf = false;
        this.previewFileId = "";
        this.previewRenderKey++;
        return;
      }

      const extension = (fileDetail.extension || "").toLowerCase();
      const fileName = (fileDetail.name || fileDetail.file_name || "").toLowerCase();
      const fileType = String(fileDetail.type || fileDetail.mime_type || "").toLowerCase();
      const rawFileType = String(
        fileDetail.raw && fileDetail.raw.type ? fileDetail.raw.type : ""
      ).toLowerCase();
      const isPdfFile =
        extension === ".pdf" ||
        fileName.endsWith(".pdf") ||
        fileType === "pdf" ||
        fileType === "application/pdf" ||
        rawFileType === "application/pdf";

      this.isPdf = isPdfFile;
      this.previewFileId = fileDetail.id;
      this.url = isPdfFile
        ? ExtensionService.getDocumentPreviewUrl(fileDetail.id)
        : ExtensionService.urlDowloadFile + fileDetail.id;
      this.previewRenderKey++;
    },
  handleChangeSignature( index,item) {

      const signers = this.mData.dataForm.signers;

      if (item.is_digital_signature) {
        for (let i = index; i < signers.length; i++) {
          signers[i].is_digital_signature = true;
        }
      }

      console.log('signers after change signature:', signers);
    },
    reRenderDraggable() {
      this.componentRerender3++;
    },

    validateFieldMethod(prop, val) {
      this.$refs['formCreateDocumentIn'].validateField(prop)
      this.forceUpdateUI()
    },

    fn_goToTemplateCreate() {
      this.$router.push({
        name: "Admin-ElectronicDocument-template-create",
        query: { type: this.$route.query.type || "DOC_SIGN" },
      });
    },

    fn_checkIsSelected() {
      const emptyObj = this.mData.dataForm.signers.find(signer => signer.user_id == null);
      if (emptyObj) {
        this.$notify.info({
          message: "Vui lòng chọn toàn bộ người ký.",
          duration: 3000,
          customClass: "doc-info",
        });
        return;
      }
      this.isDraggable = true;
    },

    fn_getManipulatelyPosition(userId, idx, reselect, positionId, fields) {
      this.componentRerender1++;
      // Check duplicate
      this.checkDulicateUserVsPosition(userId, positionId, idx, fields)
      // Clear position_id when reselect person
      if (this.mData.dataForm.signers[idx].position_id && reselect) {
        this.mData.dataForm.signers[idx].position_id = "";
      }
      const emp = this.mData.dataDefault.listEmployee.find(
          (e) => e.id == userId
        );
      if(emp != null && !emp.user_name){
        this.mData.dataForm.signers[idx].user_no = emp && emp.employee_no ? emp.employee_no : "";
        this.mData.dataForm.signers[idx].user_name = `${
          emp && emp.administrative_info.name.full_name
            ? (emp && emp.employee_no ? '-' : '') + emp.administrative_info.name.full_name
            : ""
        }`;
      }

      if (this.arrTwoWay.hasOwnProperty(userId)) {
        return this.arrTwoWay;
      } else {
        this.arrTwoWay[userId] =
          emp != null ? _.uniqBy(MethodService.getValidJobInfo(emp.job_info, this.mData.dataDefault.listContractTypeId), "position_id") : [];
        this.arrTwoWay[userId].forEach((item1) => {
          this.mData.dataDefault.listPosition.forEach((item2) => {
            if (item1.position_id == item2.id) {
              item1.position_name = item2.name ? item2.name : "Không xác định";
            }
          });
        });
      }
    },

    checkDulicateUserVsPosition(userId, positionId, index, fields) {
      if (userId == null || positionId == null) return
       this.mData.dataForm.signers.find((person, i) => {
        if (i == index || person.user_id == null || person.position_id == null) return
        if (person.user_id == userId && person.position_id == positionId) {
          this.$notify.info({
            message: `${this.getNameUser(userId)} - ${this.getPositonName(positionId)} đã tồn tại trong danh sách người ký.`,
            duration: 3000,
            customClass: "doc-info",
          });
          this.mData.dataForm.signers[index][fields] = null
        }
      })
      // Get manipulately position_name
      const pos = this.mData.dataDefault.listPosition.find(
        (p) => p.id == this.mData.dataForm.signers[index].position_id
      );
      if (pos) {
        this.mData.dataForm.signers[index].position_name = pos.name;
      }
      this.componentRerender2++;
    },

    getNameUser(userId) {
      let user = this.mData.dataDefault.listEmployee.find(e => e.id == userId)
      return user.administrative_info.name.full_name
    },

    getPositonName(positionId){
      let position = this.mData.dataDefault.listPosition.find(e => e.id == positionId)
      return position.name
    },

  addSigner() {
  const signers = this.mData.dataForm.signers || [];

  // Nếu danh sách không rỗng, lấy chữ ký số của người cuối; nếu rỗng thì mặc định là false
  var lastSigner = signers.length > 0 ? signers[signers.length - 1] : null;
var isDigitalSignature = lastSigner && lastSigner.is_digital_signature === true;

  // Thêm người ký mới
  signers.push({
    user_id: null,
    position_id: null,
    status: signers.length === 0 ? "WAITING" : "NEW",
    is_digital_signature: isDigitalSignature || false, // fallback rõ ràng
  });

    // Thêm validate tương ứng
    this.mData.validForm.signers.push({
      user_id: [ValidService.requiredChange],
      position_id: [ValidService.requiredChange],
    });

    this.forceUpdateUI();
  },

    removeSigner(idx) {
      this.mData.dataForm.signers.splice(idx, 1);
      this.forceUpdateUI();
    },

    async fn_viewDepartmentEmployee(rowId) {
      this.dataDepartmentEmployee = [];
      this.dialogDepartmentEmployee = true;
      await this.fn_getListDepartment();
      await this.fn_getListPosition();
      await this.fn_getListEmployeeByDepartmentId(rowId);
    },

    async fn_getListOrganizationModel() {
      const organizationModelApiRes = await OrganizationModelApi.list({
        limit: 99999,
        sort: "order",
      });
      if (organizationModelApiRes.result) {
        this.mData.dataDefault.listOrganizationModel =
          organizationModelApiRes.result;
      }
    },

    fn_standardizeDataSigner(dataSigner) {
      if (dataSigner && dataSigner.length > 0) {
        dataSigner.forEach((signer, i) => {
          if (i == 0) {
            dataSigner[0].status = "WAITING";
          } else {
            signer.status = "NEW";
          }
        });
      }
    },

    fn_submitForm(type) {
      this.$refs["formCreateDocumentIn"].validate(async (valid) => {
        if (!valid) return false
        try {
          let data = this.mData.dataForm;
          if (!data.doc_file.hasOwnProperty("doc_id")) {
            this.$notify.info({
              message: "Vui lòng tải file chính lên.",
              duration: 3000,
              customClass: "doc-info",
            });
            return;
          }
          if (
            !data.effected_date.is_has_effected_after_signed &&
            !data.effected_date.start_effected_at
          ) {
            this.$notify.info({
              message: "Vui lòng chọn ngày hiệu lực văn bản.",
              duration: 3000,
              customClass: "doc-info",
            });
            this.$refs.startEffectedDate.focus();
            return;
          }
          const objDocType = this.mData.dataDefault.listDocumentType.find(
            (o) => o.id == data.document_category_id
          );
          data.code = objDocType ? objDocType.code : "Không xác định";
          data.name = data.name ? data.name.trim() : "";
          data.company_id = this.mData.currentCompany.id;
          data.author_id = this.mData.currentUser.id;
          data.sent_at_to = new Date();
          data.status = "NEW";
          data.description = data.description ? data.description.trim() : "";
          data.secret_id = data.secret_id ? data.secret_id : null;
          data.urgency_id = data.urgency_id ? data.urgency_id : null;
          await this.fn_standardizeDataSigner(data.signers);
          delete data.transfer;
          delete data.comments;
          if (type == "create") {
            if (data.signers) {
              data.signers = data.signers.map((signer) => {
                if (signer.position) {
                  delete signer.position;
                  delete signer.signed_file_id;
                  delete signer.sign_image_id;
                }
                return signer;
              });
            }
            const documentInApiRes = await DocumentApi.create(data);
            await this.fn_checkFileType(documentInApiRes.result, type);

          } else if (type == "update") {
            const documentInApiRes = await DocumentApi.update(data);
            await this.fn_checkFileType(documentInApiRes.result, type);
          }
        } catch (error) {
          if (error.code == "402") {
            this.$notify.warning({
              message: "Vui lòng tải file chính lên.",
              duration: 3000,
              customClass: "doc-warning",
            });
            return;
          } else if (error.code == 500) {
            this.loading = false;
            this.$notify.warning({
              message: `${error.detail}.`,
              duration: 3000,
              customClass: "doc-warning",
            });
            return;
          }
          this.loading = false;
          this.$notify.warning({
            message: "Thêm văn bản thất bại. Vui lòng thử lại.",
            duration: 3000,
            customClass: "doc-warning",
          });
        }
      });

    },

    async fn_checkFileType(res, handle) {
      this.loading = true;
      if (handle == "create" && this.mData.dataForm.doc_file.type == "pdf") {
        this.$notify.success({
          // dangerouslyUseHTMLString: true,
          // message: '<strong>This is <i>HTML</i> string</strong>'
          message: "Thêm văn bản thành công.",
          duration: 3000,
          customClass: "doc-success",
        });
        await this.fn_goToDetail(res, this.$route.query.type);
      } else if (
        handle == "create" &&
        (this.mData.dataForm.doc_file.type == "doc" ||
          this.mData.dataForm.doc_file.type == "docx" ||
          this.mData.dataForm.doc_file.type == "xlsx" ||
          this.mData.dataForm.doc_file.type == "xls")
      ) {
        setTimeout(() => {
          this.loading = false;
          this.$notify.success({
            message: "Thêm văn bản thành công.",
            duration: 3000,
            customClass: "doc-success",
          });
          this.fn_goToDetail(res, this.$route.query.type);
        }, 1000);
      } else if (
        handle == "update" &&
        this.mData.dataForm.doc_file.type == "pdf"
      ) {
        this.$notify.success({
          message: "Cập nhật văn bản thành công.",
          duration: 3000,
          customClass: "doc-success",
        });
        await this.fn_goToDetail(res, this.$route.query.type);
      } else if (
        handle == "update" &&
        (this.mData.dataForm.doc_file.type == "doc" ||
          this.mData.dataForm.doc_file.type == "docx" ||
          this.mData.dataForm.doc_file.type == "xlsx" ||
          this.mData.dataForm.doc_file.type == "xls")
      ) {
        setTimeout(() => {
          this.loading = false;
          this.$notify.success({
            message: "Cập nhật văn bản thành công.",
            duration: 3000,
            customClass: "doc-success",
          });
          this.fn_goToDetail(res, this.$route.query.type);
        }, 1000);
      }
    },

    fn_goToDetail(idDoc) {
      this.$router
        .push({
          name: "Admin-" + this.mData.moduleName + "-detail",
          params: { id: idDoc },
          query: {
            type:
              this.viewMode == "create" ? "DOC_SIGN" : this.$route.query.type,
            from: this.$route.query.recreate
              ? "recreate"
              : this.$route.query.edit
              ? "edit"
              : "create",
          },
        })
        .catch((err) => {});
    },

    fn_resetForm() {
      this.$refs["formCreateDocumentIn"].resetFields();
    },

    fn_fillPositionManipulately(data) {
      if (data) {
        data.forEach((item, i) => {
          this.fn_getManipulatelyPosition(item.user_id, i, false);
        });
      }
    },

    async fn_setUpDefault() {
      if (!this.mData.dataForm.effected_date) {
        this.mData.dataForm.effected_date = {
          start_effected_at: null,
          end_effected_at: null,
          is_has_effected_after_signed: null,
        };
      }
      if (this.$route.query.fromDetail && this.$route.query.recreate)
        this.isEdit = true;
      if (
        this.$route.query.fromDetail &&
        (this.$route.query.recreate || this.$route.query.edit)
      ) {
        await this.fn_getDocById(this.$route.query.fromDetail);
        await this.fn_fillPositionManipulately(this.mData.dataForm.signers);
        await this.forceUpdateUI();
        this.viewMode = this.$route.query.edit ? "update" : "create";
      } else if (this.$route.query.fromDetail && !this.$route.query.recreate) {
        this.mData.dataForm.doc_file.doc_id = this.$route.query.fromDetail;
        this.mData.dataForm.doc_file.doc_name = this.$route.query.doc_name;
        this.mData.dataForm.doc_file.type = this.$route.query.doc_type;
        this.mData.dataForm.doc_file.capacity = this.$route.query.capacity;
        this.fn_getMainFileFromDetail();
      }
      this.mData.dataForm.sent_at_from = new Date();
      this.mData.dataForm.book.book_date = new Date();

      if (
        !this.$route.query.fromDetail ||
        (this.$route.query.fromDetail &&
          !this.$route.query.recreate &&
          !this.$route.query.edit)
      ) {
        this.mData.dataForm.publish.is_auto = false;
        this.mData.dataForm.effected_date.is_has_effected_after_signed = true;
      }
      if (
        this.$route.query.fromDetail &&
        (this.$route.query.recreate || this.$route.query.edit)
      ) {
        return;
      }
      this.mData.dataForm.urgency_id = "Bình thường";
      this.mData.dataForm.secret_id = "Bình thường";
      this.mData.dataForm.type = "INTERNAL_DOC";
    },

    async fn_getDocById(id) {
      const documentInApiRes = await DocumentApi.findById(id);
      if (documentInApiRes.result) {
        this.mData.dataForm = documentInApiRes.result;
        await this.fn_getMainFile();
        this.fn_getOtherFiles();
        this.fn_deleteAutoVT(this.mData.dataForm);

        this.mData.dataForm.signers = this.mData.dataForm.signers ? this.mData.dataForm.signers : [];
        if (!this.mData.dataForm.effected_date) {
          this.mData.dataForm.effected_date = {
            start_effected_at: null,
            end_effected_at: null,
            is_has_effected_after_signed: true,
          };
        }
        await this.fn_getMainFileURL();
        if (this.$route.query.fromDetail && this.$route.query.recreate) {
          this.mData.dataForm.histories = []
          this.mData.dataForm.ref_id = null
        }
      }
    },

    async fn_getMainFileFromDetail() {
      const listFile = await FileApi.list(
        {
          filters: `id=${this.$route.query.fromDetail}`,
        },
        true
      );
      let data = [];
      if (listFile && listFile.result) {
        data = listFile.result;
        data.map((item) => {
          item.url = ExtensionService.getDocumentPreviewUrl(item.id);
        });
      }
      this.mData.fileUploadOption.fileMain.fileList = data;

      const fileDetail = this.mData.fileUploadOption.fileMain.fileList[0];
      this.applyPreviewFile(fileDetail);
    },

    async fn_getMainFile() {
      if (
        this.mData.dataForm.doc_file &&
        this.mData.dataForm.doc_file.doc_id
      ) {
        const listFile = await FileApi.list(
          {
            filters: `id=${this.mData.dataForm.doc_file.doc_id}`,
          },
          true
        );
        let data = [];
        if (listFile && listFile.result) {
          data = listFile.result;
          data.map((item) => {
            item.url = ExtensionService.getDocumentPreviewUrl(item.id);
          });
        }
        this.mData.fileUploadOption.fileMain.fileList = data;
      }
    },

    async fn_getOtherFiles() {
      if (
        this.mData.dataForm.other_files &&
        this.mData.dataForm.other_files.length > 0
      ) {
        const listFileId = this.mData.dataForm.other_files.map(
          (file) => file.other_id
        );
        const listFile = await FileApi.list(
          {
            limit: this.mData.dataForm.other_files.length,
            filters: "id:in:" + listFileId.join(","),
          },
          true
        );
        let data = [];
        if (listFile && listFile.result) {
          data = listFile.result;
          data.map((item) => {
            item.url = ExtensionService.getDocumentPreviewUrl(item.id);
          });
        }
        this.mData.fileUploadOption.fileOther.fileList = data;
      } else {
        this.mData.dataForm.other_files = [];
      }
    },

    fn_deleteAutoVT(data) {
      if (this.$route.query.fromDetail && this.$route.query.recreate) {
        data.signers = data.signers.filter(signer => !signer.is_add_auto)
      }
    },

    fn_getMainFileURL() {
      let fileDetail = {};
      if (
        this.mData.dataForm.doc_file &&
        this.mData.dataForm.doc_file.doc_id
      ) {
        fileDetail = this.mData.fileUploadOption.fileMain.fileList[0];
      } else {
        fileDetail = this.mData.fileUploadOption.fileOther.fileList[0];
      }
      this.applyPreviewFile(fileDetail);
    },

    async fn_initData() {
      this.fn_getListConTractType();
      this.fn_getListDocumentRespectively("DOC_TYPE");
      this.fn_getListOrganizationModel();
      this.fn_getListEmployee();
      await this.fn_getListPosition();
      this.fn_getListDocumentBusiness();
    },
  },
  async created() {
    await this.fn_initData();
    await this.fn_setUpDefault();
    this.fn_eventBus('','new')
  },
};
</script>

<style lang="scss" scoped>
.custom-checkbox {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 80px; /* hoặc auto nếu dùng nhiều checkbox */
}

.custom-checkbox .el-checkbox {
  margin: 0;
}

.checkbox-label {
  font-size: 14px;
  margin-top: 4px;
  color: #333;
  text-align: center;
  line-height: 1.2;
}
.listSigner-move,
/* apply transition to moving elements */
.listSigner-enter-active,
.listSigner-leave-active {
  transition: all 0.5s ease;
}
.list-group-item {
  border: 1px solid var(--turquoise);
  border-radius: 5px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.16);
  overflow: hidden;
  cursor: move;
  .single__item {
    color: var(--turquoise);
    padding: 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .single__item-name {
      text-align: left;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 90%;
    }
  }
}
::v-deep .el-checkbox {
  .el-checkbox__input.is-checked {
    .el-checkbox__inner {
      background-color: var(--turquoise);
      border-color: var(--turquoise);
    }
  }
  .el-checkbox__input.is-focus {
    .el-checkbox__inner {
      border-color: var(--turquoise) !important;
    }
  }
  .el-checkbox__input.is-indeterminate {
    .el-checkbox__inner {
      background-color: var(--turquoise);
      border-color: var(--turquoise);
    }
  }
  .el-checkbox__inner {
    width: 16px;
    height: 16px;
    border-radius: 4px;
    border-color: var(--turquoise);
    top: -2px;
    &:hover {
      border-color: var(--turquoise) !important;
    }
    &:focus {
      border-color: var(--turquoise) !important;
    }
    &:active {
      border-color: var(--turquoise) !important;
    }
  }
}
::v-deep .left-side {
  .btn-add-signer {
    height: 42px;
    background: var(--white);
    border: 1px dashed #c8ced3;
    border-radius: 5px;
    padding: 9px 10px;
    margin-left: 127px;
    cursor: pointer;
    transition: 0.1s ease;
    &:hover {
      color: var(--turquoise);
      border: 1px dashed var(--turquoise);
    }
  }
  .btn-arrange-complete {
    height: 42px;
    color: white;
    background: var(--turquoise);
    border: 1px solid var(--turquoise);
    border-radius: 5px;
    padding: 9px 10px;
    cursor: pointer;
    transition: 0.1s ease;
    &:hover {
      border: 1px solid var(--turquoise);
      background-color: var(--white);
      color: var(--turquoise);
    }
    &:active {
      border: 1px solid var(--turquoise);
      background-color: var(--turquoise);
      color: var(--white);
    }
    &:focus {
      border: 1px solid var(--turquoise);
      background-color: var(--turquoise);
      color: var(--white);
    }
  }
  .btn-arrange {
    height: 42px;
    color: var(--turquoise);
    border: 1px solid var(--turquoise);
    border-radius: 5px;
    padding: 9px 10px;
    cursor: pointer;
    transition: 0.1s ease;
    &:hover {
      border: 1px solid var(--turquoise);
      background-color: var(--turquoise);
      color: var(--white);
    }
    &:active {
      border: 1px solid var(--turquoise);
      background-color: var(--white);
      color: var(--turquoise);
    }
    &:focus {
      border: 1px solid #487d9c;
      background-color: #487d9c;
      color: var(--white);
    }
  }
  .fa-question-circle {
    position: absolute;
    top: 15px;
    right: 10px;
    &:hover {
      color: var(--red);
    }
  }
  .signers-container {
    .el-icon-close {
      font-size: 20px;
      height: 20px;
      margin-top: 10px;
      color: var(--red);
      cursor: pointer;
    }
  }
  .el-upload-dragger {
    width: 100%;
    height: 95px;
  }
}
::v-deep .right-side {
  background-color: #d0d5d9;
  position: sticky;
  top: 0;
  height: calc(100vh - 100px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .remove__file-footer {
    flex-shrink: 0;
    background-color: rgba(41, 45, 50, 0.7);
    width: 100%;
    padding: 10px;
    transition: 0.3s ease;
    cursor: pointer;
    &:hover {
      background-color: rgba(41, 45, 50, 0.95);
    }
  }
  .preview__file-container {
    background: #bebebe;
    width: 100%;
    height: calc(100% - 48px);
    box-shadow: 7px 7px 21px -7px rgb(0, 0, 0, 30%);
    overflow: auto;
    position: relative;
    iframe, .docx-viewer, .vue-doc-preview {
      min-width: unset !important;
      max-width: 100%;
      width: 100% !important;
    }
  }
  .upload {
    height: 45%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }
  .download-ref {
    color: rgb(30, 60, 215);
    line-height: 24px;
    position: absolute;
    top: 36%;
    left: 50%;
    transform: translateX(-50%);
    cursor: pointer;
  }
  .icon {
    font-size: 74px !important;
    color: black !important;
  }
  .el-upload-dragger {
    padding: 20px;
    background-color: transparent;
    width: 100%;
    height: auto;
    .el-upload__tip {
      p {
        font-size: 14px;
      }
    }
  }
  .to__draff__documnet {
    margin: 0 auto;
    margin-top: 140px;
    max-width: 450px;
    text-align: center;
    padding: 20px;
    .text__block {
      .main__text {
        font-size: 24px;
        color: #1e3cd7;
      }
      .sub__text {
        color: #7e7e7e;
        line-height: 24px;
      }
    }
    &:hover {
      border: 1px dashed #409eff;
      cursor: pointer;
    }
  }
}
::v-deep .icon {
  cursor: pointer;
}
::v-deep .isax-trash {
  color: var(--red);
}
::v-deep .isax-eye {
  color: var(--orange);
}

::v-deep .el-upload {
  position: relative;
  display: block;
}
::v-deep .el-upload__tip {
  p {
    font-size: 13px;
  }
}
::v-deep .el-card {
  border-radius: 0 !important;
  border: none;
  .el-card__body {
    padding: 5px;
  }
  .el-form {
    padding: 20px 10px 10px;
  }
}
::v-deep .el-input__inner {
  border-radius: 0;
  box-shadow: none !important;
  border-radius: 5px !important;
}
::v-deep .el-textarea {
  .el-textarea__inner {
    border-radius: 0;
    box-shadow: none !important;
    border-radius: 5px !important;
    padding-bottom: 15px;
  }
  .el-input__count {
    background: transparent;
    right: 4px;
    bottom: -6px;
  }
}
::v-deep .el-divider--horizontal {
  width: 95% !important;
  margin: 24px auto;
  .el-divider__text {
    background-color: #d0d5d9;
    padding: 0 50px;
  }
}
::v-deep .divider-custom {
  width: 70% !important;
  background-color: black !important;
  .el-divider__text {
    font-size: 18px;
  }
}
::v-deep .el-form-item__label {
  font-weight: bold;
  text-align: left;
}
::v-deep .el-card--form {
  border: 1px solid rgb(126, 126, 126);
  padding: 3px 3px 3px 0;
  .el-card__body {
    // max-height: calc(100vh - 167px);
    overflow: auto;
  }
}
@media (min-width: 1366px) {
  ::v-deep .left-side {
    .el-upload-dragger {
      height: 95px;
    }
  }
}
@media (max-width: 1190px) {
  ::v-deep .datePicker {
    width: 155px;
  }
  ::v-deep .btn__doc {
    margin-bottom: 10px;
  }
}
</style>
